import { Component, OnInit, OnDestroy, Inject, HostListener } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Router } from '@angular/router';
import { JoyrideService } from 'ngx-joyride';
import * as _ from 'lodash';
/** Inject d3 from web browser */
declare const d3: any;
import * as d3Tip from 'd3-tip';
(d3 as any).tip = d3Tip;
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

import { DataEnadisService } from '../../services/data-enadis/data-enadis.service';
import { Question } from '../../models/question.class';
import { Entry } from '../../models/entry.class';
import { FormControl } from '@angular/forms';
import { ErrorCatchDialogComponent } from '../../dialogs/error-catch-dialog/error-catch-dialog.component';
import { FilterRadiobuttonPopupComponent } from '../../components/filter-radiobutton-popup/filter-radiobutton-popup.component';
import { UtilsService } from '../../services/utils/utils.service';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AxisOption } from '../../models/axisOption.class';
import { ConfigVariable } from '../../models/ConfigVariable.class';

/** Text that represents ALL options selected */
const ALL = 'Todos';
/** Text that represents when there are only TWO options and BOTH are selected */
const BOTH = 'Ambos';
/** Text that represents whole geography */
const NATIONAL = 'Nacional';

/**
 * EnadisGraphsComponent
 * Catch question selected and use it to render graphs module
 */
@Component({
  selector: 'app-enadis-graphs',
  templateUrl: './enadis-graphs.component.html',
  styleUrls: ['./enadis-graphs.component.scss']
})
export class EnadisGraphsComponent implements OnInit, OnDestroy {
  /** Text to display on share buttons */
  sharetext: string;
  /** Page can be shared or not (url) */
  sharePage: boolean;
  /** Image to download */
  imageJPG: string;
  /** Show slider */
  showSlider: boolean;
  /** Source of the data, to display in view */
  source: string;
  /** List of questions */
  variables: Question[];
  /** List of questions that could be used to compare with first one */
  secondVariables: Question[] = [];
  /** Form control to search questionnaires */
  searchQuestionnaires: FormControl;
  /** Name of selected population group */
  selectedGroup: string;
  /** Population group selected */
  selectedGroupName: PopulationGroup;
  /** Name of selected ambit */
  selectedAmbito: string;
  /** Question instance to refer to selected topic */
  selTopic: Question;
  /** Question instance to refer to selected questionnaire */
  selectedQuestionnaire: Question;
  /** Selected question instance */
  selectedQuestion: Question;
  /** Second selected question instance */
  selectedSecondQuestion: Question;
  /** Form control to search second question */
  searchSecondQuestion: FormControl;
  /** Selected axis option */
  xAxis: AxisOption;
  /** Selected xAxisGroupBy option */
  xAxisGroupBy: AxisOption;
  /** Selected y axis option */
  yAxis: AxisOption;
  /** Selected collapse by option */
  collapseBy: AxisOption;
  /** If bars should be stacked */
  stackBy: boolean;
  /** If bars should be grouped by */
  groupedBy: string;
  /** Identifier of selected question */
  questionId: string;
  /** Name of selected chart */
  selectedChart: string;
  /** Url of current page */
  url: string;
  /** Labels reference to increase and decrease font size */
  fontBars: any;
  /** Current value of labels' font size */
  resBars: any;
  /** Comment for the question */
  comment: any;
  /** Key words of selected question */
  questionKeywords: string[];
  /** Selected key word */
  selectedKeyword: string;
  /** Filtered second variables list */
  filteredSecondVariables: any = [];
  /** Data got from request to draw */
  dataToDraw: Entry[] = [];
  /** Filtered data to draw*/
  filteredData: Entry[];
  /** Subscriber of params */
  private sub: any;
  /** Subscriber of query params */
  private subQueryParams: any;
  /** Axis options available */
  axisOptions: AxisOption[] = [];
  /** X axis options available */
  xAxisOptions: AxisOption[] = [];
  /** Y axis options available */
  yAxisOptions: AxisOption[] = [];
  /** Options to display in groupby buttons */
  groupByOptions: { id: string, name: string, shortName: string }[] = [];
  /** Items to groupby */
  groupByItems: AxisOption[] = [];
  /** Object defining charts that should be enabled to select */
  chartsEnabled = {
    bars: true,
    heatmap: true,
    spineplot: true,
    timeline: false,
    scatter: false,
    treemap: true,
    map: false
  };
  /** Whole filter options */
  filterOptions: {
    unidad: string[],
    categories: string[],
    columns: string[],
    secondCategories: string[],
    secondColumns: string[]
  };
  /** Selected filters object */
  selectedFilters = {};
  /** Dbox chart instance */
  chart: any;
  /** Orderby selected option */
  orderBy: string;
  /** Legend options to display */
  legendOptions: Array<any>;
  /** Legend title */
  legendTitle: string;
  /** Sprtby options */
  sortBy = {
    showSortOptions: false,
    names: true,
    valuesAscending: false,
    valuesDescending: false
  };
  /** Show color palettes options */
  showColorsOptions = false;
  /** Display label size options */
  showSizeOption = false;
  /** Show filters panel */
  showFilters = false;
  /** Defined scales */
  scales: any;
  /** Show labels options */
  showLabelsOptions = false;
  /** Backup when selecting a scatter plot */
  backupScatter: any;
  /** List of all questions */
  allVariables: Question[];
  /** Display "loading data" loader */
  loadingData: boolean;
  /** Value to display progress */
  progress: any;
  /** Percentage completed to display data */
  counter: number;
  /** Show popup to select columns and categories */
  showPopup = true;
  /** Config autocompletes for variables */
  variableAutocompleteConfig: ConfigVariable;
  /** Allow multiple filters in filters panel */
  multipleFilters: boolean;
  /** Named filters to display in panel */
  namedFilters: { name: string, slug: string, selected: string }[];
  /** Siwtch to change view from chart to table */
  switchViewMob = true;
  /** Selected palette of colors */
  colors: string[];
  /** Defined inner width (related with margins) */
  innerWidth: any;
  /** Enable mobile menu */
  enableMobileMenu: boolean;
  /** Disable checkboxes from legend */
  checkboxDisabled = false;
  /** Selected sub topic */
  selectedSubTopic: string;
  /** Hide subdivition options */
  hideSubdivition: boolean;
  /** Labels should be displayed */
  labelsVisible = false;
  /** Generated title for whole chart */
  generatedTitle: string;
  /** Categorical color palettes */
  categoricalPalettes: string[][];
  /** Available color palettes */
  availablePalettes: string[][];
  /** Sequential color palettes */
  sequentialPalettes: string[][];
  /** Disable modal */
  disableModal: boolean;
  /** Y axis should be disabled */
  disabledYAxis: boolean;
  /** X axis should be disabled */
  disabledXAxis: boolean;
  /** Show order by options */
  showOrderBy: boolean;

  /** 
   * Init component, inject services for routes, location, dialogs, data, 
   * joyride and webstorage 
   * @param location Angular Location Service
   * @param route Angular ActivatedRoute
   * @param dbService ENADIS database service
   * @param utils General utils methods
   * @param router Angular Router service
   * @param dialog Angular Material MatDialog
   * @param storage Web Storage Service
   */
  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private dbService: DataEnadisService,
    public utils: UtilsService,
    private router: Router,
    private dialog: MatDialog,
    private readonly joyrideService: JoyrideService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService) { }

  /** OnInit component, define default properties values */
  ngOnInit() {
    this.categoricalPalettes = this.utils.getCategoricalColors();
    this.sequentialPalettes = this.utils.getSequentialColors();
    this.disabledXAxis = false;
    this.selectedChart = 'bars';
    this.source = 'Enadis (2017)';
    this.setColorPalette();
    this.hideSubdivition = true;
    this.disableModal = true;
    this.loadingData = false;
    this.showOrderBy = true;
    this.variableAutocompleteConfig = {
      mode: 'grupos',
      selectedTopic: '',
      selectedSubtopic: '',
      selectedQuestion: undefined
    };
    this.allVariables = [];
    this.multipleFilters = true;
    this.counter = 0;
    this.scales = {};
    this.searchSecondQuestion = new FormControl();
    this.sharePage = false;
    this.showSlider = false;
    this.sharetext = 'CONAPRED - ENADIS';
    this.url = 'http://sindis.conapred.org.mx/estadisticas/enadis/';
    this.xAxis = _.find(this.axisOptions, { slug: 'categories' }); // Default value for x axis
    this.yAxis = _.find(this.axisOptions, { type: 'linear' }); // Default value for y axis
    this.collapseBy = _.find(this.axisOptions, { type: 'linear' }); // Default value for y axis
    this.groupedBy = '';
    this.xAxisGroupBy = _.find(this.groupByItems, { slug: 'categories' });
    this.stackBy = false;
    this.orderBy = 'categories';
    this.legendOptions = [];
    this.filterOptions = {
      unidad: ['Total', 'Porcentaje'],
      categories: [],
      columns: [],
      secondCategories: [],
      secondColumns: []
    };

    // Get params from url
    this.subQueryParams = this.route.queryParams.subscribe((params: Params) => {
      this.sub = this.route.params.subscribe((paramsRout: Params) => {
        this.questionId = paramsRout['idQuestion'];
        // Chart is selected
        if (params['chart'] && Object.keys(this.chartsEnabled).includes(params['chart'])) {
          this.selectedChart = params['chart'];
        } else {
          this.selectedChart = 'bars'; // Default chart
        }
        this.setColorPalette();
        this.disabledYAxis = this.selectedChart === 'bars' ? true : false;
        if (this.questionId) {
          this.dbService.getCodebook() // Get all questions
            .subscribe(questions => {
              this.allVariables = questions;
              this.selectedQuestion = this.allVariables.find(o => o.questionId === this.questionId);

              this.secondVariables = this.allVariables.filter(function (v) {
                return _.includes(['Características de la vivienda',
                  'Características de los hogares',
                  'Características sociodemográficas',
                  this.selectedQuestion.topic], v.topic);
              }.bind(this));
              this.selectedSecondQuestion = this.secondVariables[0];
              this.searchSecondQuestion.setValue(this.secondVariables[0]);

              if (this.secondVariables && this.secondVariables.length > 0) {
                this.selectedSecondQuestion = this.secondVariables[0];
                this.searchSecondQuestion.setValue(this.selectedSecondQuestion);
              }
              this.variableAutocompleteConfig = {
                mode: params.mode,
                selectedTopic: params.selectedTopic,
                selectedSubtopic: params.mode === 'grupos' ? this.selectedQuestion['subtopic'] : params.selectedSubtopic,
                selectedQuestion: this.selectedQuestion
              };
              this.selectedSubTopic = this.variableAutocompleteConfig.selectedQuestion.topic;
              this.selectedGroupName = this.dbService.findGroup(params.selectedTopic);
              if (this.selectedGroupName === undefined) {
                if (this.variableAutocompleteConfig.selectedQuestion.Ambito === 'Vivienda') {
                  this.selectedSubTopic = this.variableAutocompleteConfig.selectedQuestion.subtopic;
                  this.selectedGroupName = this.dbService.findGroup(this.selectedSubTopic);
                }
                this.selectedGroupName = this.dbService.findGroup(this.selectedSubTopic);
              }
              this.setOptions();
            }, error => {
              console.error(error);
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: error.error.message.toString() || error.statusText.toString() ||
                    error.error.toString() || error
                }
              });
            });
        }
      });
    });

    this.filteredSecondVariables = this.searchSecondQuestion.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.secondVariables)) {
            return variable ? this.filterSecondVariables(variable) : this.secondVariables.slice();
          } else {
            return [];
          }
        })
      );
    this.innerWidth = window.innerWidth; // Get screen width for first time
    this.enableMobileMenu = this.innerWidth <= 600 ? true : false; // Enable 'interest variable menu' based on screem width
  }

  /**
   * Set available color palette, depending on selected chart
   */
  setColorPalette() {
    if (_.includes(['heatmap', 'map'], this.selectedChart)) {
      this.availablePalettes = this.sequentialPalettes;
    } else {
      this.availablePalettes = this.categoricalPalettes;
    }
    this.colors = this.availablePalettes[0];
  }

  /**
   * Change color of chart values when color palette has changed
   * @param palette Array or colors to be set
   */
  onPaletteChanged(palette: string[]) {
    this.colors = palette;
    this.colorCheckboxes();
  }

  /** Returns filters object for the ones that should be displayed in filters panel */
  includeFilters(): {} {
    const copy = Object.assign({}, this.filterOptions);
    let colorGroup = true;

    if (this.selectedGroupName && this.selectedGroupName.slug !== 'Cuestionario de opiniones y experiencias' &&
      this.selectedGroupName.slug !== 'Características sociodemográficas') {
      colorGroup = false;
    }

    if (this.selectedQuestion && this.selectedQuestion.kind === 'fila') {
      delete copy.columns;
    }
    if (this.selectedSecondQuestion && this.selectedSecondQuestion.kind === 'fila') {
      delete copy.secondColumns;
    }
    if (this.selectedQuestion && this.selectedQuestion.collapseBy !== 'FACTOR_COE') {
      delete copy['ENT'];
    }
    if (this.selectedQuestion && this.selectedGroupName && this.selectedGroupName.name === 'Personas de la diversidad sexual') {
      delete copy['ENT'];
    }
    if (!colorGroup) {
      delete copy['COLOR_PIEL'];
    }
    if (this.selectedGroup === 'Personas adultas mayores') {
      delete copy['RANGO_EDAD'];
    }
    return copy;
  }

  /** Filter and format filters with names to be displayed in filters panel */
  generateNamedFilters() {
    if (this.selectedFilters && this.selectedQuestion) {
      const fields = _.cloneDeep(this.selectedQuestion['fieldOptions']);
      if (this.selectedQuestion['kind'] === 'columna') {
        fields.push({ name: this.selectedQuestion['categoryName'], slug: 'columns', options: [] });
        fields.push({ name: this.selectedQuestion['subcategoryName'], slug: 'categories', options: [] });
      } else {
        fields.push({ name: this.selectedQuestion['categoryName'], slug: 'categories', options: [] });
      }
      this.namedFilters = Object.keys(this.selectedFilters).filter(o => {
        return _.includes(fields.map(f => f.slug), o) && !_.includes([ALL, BOTH, NATIONAL], this.selectedFilters[o]);
      }).map(function (o) {
        const found = fields.find(f => f.slug === o);
        return {
          name: found.name,
          slug: o,
          selected: this.selectedFilters[o]
        };
      }.bind(this));
    }
  }

  /**
   * Generate dynamic title for current chart
   */
  generateTitle(): string {
    let title = '';
    // Selected question
    if (this.selectedChart !== 'scatter' && this.selectedQuestion) {
      title += this.selectedQuestion.question;
    }
    if (this.selectedGroupName && this.selectedGroupName.name) {
      title += ' (' + (this.selectedFilters['RANGO_EDAD'] !== 'Todos' ?
        this.selectedGroupName.name.replace(/ *\([^)]*\) */g, '') : this.selectedGroupName.name) + ')';
    }
    return title;
  }

  /** Generate a text that describes all selected fitlers */
  generateFiltersText(): string {
    let filtersText = '';
    if (this.filterOptions['columns'].length > 2) {
      filtersText += this.selectedQuestion ? this.selectedQuestion.categoryName + ': ' : 'Variable: ';
      filtersText += this.selectedFilters ? this.selectedFilters['columns'] + ' / ' : ' / ';
    }
    filtersText += this.selectedQuestion ? this.selectedQuestion.subcategoryName || this.selectedQuestion.categoryName : 'Categoría';
    filtersText += ': ';
    filtersText += this.selectedFilters ? this.selectedFilters['categories'] + ' / ' : ' / ';
    filtersText += 'Sexo: ';
    filtersText += this.selectedFilters ? this.selectedFilters['SEXO'] + ' / ' : ' / ';
    filtersText += 'Grupo de edad: ';
    filtersText += this.selectedFilters ? this.selectedFilters['RANGO_EDAD'] + ' / ' : ' / ';
    filtersText += 'Estrato de ingresos: ';
    filtersText += this.selectedFilters ? this.selectedFilters['ESTRATO'] + ' / ' : ' / ';
    filtersText += 'Tamaño de localidad: ';
    filtersText += this.selectedFilters ? this.selectedFilters['TAM_LOC'] + ' / ' : ' / ';
    if (this.collapseBy && this.collapseBy.slug === 'FACTOR_COE') {
      filtersText += 'Entidad federativa: ';
      filtersText += this.selectedFilters ? this.selectedFilters['ENT'] + ' / ' : ' / ';
    }

    return filtersText;
  }

  /**
   * Called when x axis is selected, set selected filters
   */
  selectXAxis(): void {
    if (this.xAxis.slug === 'categories'
      && this.yAxis.type === 'ordinal'
      && this.selectedQuestion.kindAnswer !== 0
      && this.selectedChart !== 'heatmap'
      && this.selectedChart !== 'spineplot') {
      this.selectedFilters['unidad'] = 'Promedio';
    }
    if (this.xAxis.slug === this.selectedQuestion.collapseBy) {
      this.selectedFilters['unidad'] = 'Porcentaje';
    }
    // Question is 'fila' and selectedChart is 'bars'
    if (this.selectedQuestion.kind === 'fila' && this.selectedChart === 'bars') {
      if (this.xAxis.slug === 'categories') {
        this.groupedBy = '';
        this.xAxisGroupBy = { name: '', type: 'ordinal', slug: '' };
      } else {
        this.groupedBy = 'categories';
        this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
      }
    }
    if (this.selectedFilters[this.xAxis.slug]) {
      this.selectedFilters[this.xAxis.slug] = this.filterOptions[this.xAxis.slug][0];
      if (this.selectedQuestion.relativePercentage && this.xAxis.slug === 'categories') {
        this.selectedFilters['categories'] = this.filterOptions['categories'][1];
      }
    }
    this.showFilterPopup();
  }

  /**
   * Called when y axis is selected. Set selected filters
   */
  selectYAxis(): void {
    if (this.yAxis.slug === 'categories'
      && this.xAxis.type === 'ordinal'
      && this.selectedQuestion.kindAnswer !== 0
      && this.selectedChart !== 'heatmap'
      && this.selectedChart !== 'spineplot') {
      this.selectedFilters['unidad'] = 'Promedio';
    }

    if (this.yAxis.slug === this.selectedQuestion.collapseBy) {
      this.selectedFilters['unidad'] = 'Porcentaje';
    }
    this.selectedFilters['categories'] = this.filterOptions['categories'][0];
    if (this.yAxis.slug === 'columns') {
      this.selectedFilters['columns'] = this.filterOptions['columns'][0];
    }
    if (this.selectedChart === 'heatmap') { // Heatmap
      this.groupedBy = this.yAxis.slug;
      this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.yAxis.slug });
    }
    this.showFilterPopup();
  }

  /** Show filters popup with columns and categories */
  showFilterPopup(): void {
    const options = ['categories'];
    if (this.selectedQuestion.kind === 'columna') {
      options.unshift('columns');
    }
    const groupedBy = (this.selectedChart !== 'heatmap' ? this.groupedBy : '');
    const intersection = _.intersection(options, [
      this.xAxis.slug,
      this.yAxis.slug,
      groupedBy
    ]);
    const difference = _.difference(options, intersection);
    if (difference.length > 0) {
      const config = this.filtersConfig();
      this.disableModal = config.disabled[difference[0]];
      if (!this.disableModal) {
        if (difference.includes('columns')) {
          this.selectedFilters['columns'] = this.selectedFilters['columns'] === 'Todos' ?
            this.filterOptions['columns'][1] : this.selectedFilters['columns'];
        } else {
          this.selectedFilters['columns'] = this.filterOptions['columns'][0];
        }

        if (difference.includes('categories')) {
          this.selectedFilters['categories'] = this.selectedFilters['categories'] === 'Todos' ?
            this.filterOptions['categories'][1] : this.selectedFilters['categories'] === '' ?
              this.selectedFilters['categories'] = 'Todos' : this.selectedFilters['categories'];
        } else {
          if (this.selectedQuestion.relativePercentage) {
            this.selectedFilters['categories'] = this.filterOptions['categories'][1];
          } else {
            this.selectedFilters['categories'] = this.filterOptions['categories'][0];
          }
        }
        const dialogRef = this.dialog.open(FilterRadiobuttonPopupComponent, {
          panelClass: 'white-themed-dialog',
          height: '400px',
          width: '500px',
          data: {
            blocks: difference,
            config: config,
            filterOptions: {
              columns: this.filterOptions['columns'].filter(o => !_.includes([ALL, BOTH, NATIONAL], o)),
              categories: this.filterOptions['categories'].filter(o => !_.includes([ALL, BOTH, NATIONAL], o))
            },
            selectedFilters: this.selectedFilters
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.updateChart();
        });
      } else {
        setTimeout(() => {
          this.updateChart();
        }, 100);
      }
    } else {
      setTimeout(() => {
        this.updateChart();
      }, 100);
    }
  }

  onChangeCollapseBy(factor: string): void {
    // this.collapseBy.slug = factor;
  }

  /** Reset filters to default axes and selected filters */
  onResetFilters(): void {
    this.setDefaultAxes();
  }

  /** Set default axes and filters for each chart */
  setDefaultAxes(): void {
    const vm = this;
    if (this.selectedChart !== 'scatter' && this.backupScatter && this.backupScatter.hasOwnProperty('xAxis')) {
      this.xAxis = this.backupScatter.xAxis;
      this.yAxis = this.backupScatter.yAxis;
    }
    if (this.axisOptions.length > 0) {
      this.groupedBy = '';
      this.generateSelectedFilters();
      this.collapseBy = _.find(this.axisOptions, { type: 'linear' });
      if (this.selectedQuestion && this.selectedQuestion.kindAnswer !== 0) {
        this.collapseBy = _.find(this.axisOptions, { slug: 'categories' });
      }
      switch (this.selectedChart) {
        case 'bars': // Bars
          this.xAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'ordinal' ||
              (o.slug === 'categories' && this.selectedQuestion.kindAnswer === 1);
          }.bind(this)).sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'linear' ||
              (o.slug === 'categories' && this.selectedQuestion.kindAnswer === 1);
          }.bind(this));
          this.xAxis = _.find(this.axisOptions, { slug: 'categories', type: 'ordinal' })
            || _.find(this.axisOptions, { slug: 'columns', type: 'ordinal' })
            || _.find(this.axisOptions, { slug: 'year', type: 'ordinal' })
            || _.find(this.axisOptions, { type: 'ordinal' });
          this.yAxis = _.find(this.axisOptions, { slug: 'categories', type: 'linear' })
            || _.find(this.axisOptions, { slug: this.selectedQuestion.collapseBy })
            || _.find(this.axisOptions, { type: 'linear' });
          if (this.yAxis && this.yAxis.slug === 'categories') {
            this.selectedFilters['unidad'] = 'Promedio';
          }
          if (this.selectedQuestion.relativePercentage) {
            this.xAxis = _.find(this.axisOptions, { slug: 'categories' });
            if (this.selectedQuestion.kind === 'columna') {
              this.selectedFilters['categories'] = 'Sí';
              this.groupedBy = 'columns';
              this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
              if (this.xAxisGroupBy === undefined) {
                this.xAxisGroupBy = { name: '', type: 'ordinal', slug: '' };
              }
            }
          } else {
            if (this.selectedQuestion.kind === 'columna') {
              this.xAxis = _.find(this.axisOptions, { slug: 'columns' });
              this.groupedBy = 'categories';
              this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
            } else {
              this.xAxis = _.find(this.axisOptions, { slug: 'categories', type: 'ordinal' }) ||
                _.find(this.axisOptions, { type: 'ordinal' });
              this.groupedBy = '';
            }
          }
          break;
        case 'heatmap': // Heatmap
          this.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.xAxis = _.find(this.axisOptions, { slug: 'categories', type: 'ordinal' })
            || _.find(this.axisOptions, { slug: 'columns', type: 'ordinal' }) || _.find(this.xAxisOptions, { slug: 'ENT' });
          this.yAxis = this.yAxisOptions.filter(o => o.type === 'ordinal' && o.slug !== vm.xAxis.slug)[0];
          if (this.yAxis) {
            this.groupedBy = this.yAxis.slug;
            this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
          }
          break;
        case 'spineplot': // Spineplotthis.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal' );
          this.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'ordinal';
          }.bind(this)).sort((a, b) => a.name < b.name ? -1 : 1);

          this.xAxis = _.find(this.xAxisOptions, { slug: 'categories' });
          this.yAxis = this.yAxisOptions.filter(o => o.type === 'ordinal' && o.slug !== vm.xAxis.slug)[0];

          if (this.yAxis) {
            this.groupedBy = this.yAxis.slug;
            this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
          }

          if (this.yAxis.slug === this.xAxis.slug) {
            this.xAxis = _.find(this.xAxisOptions, { slug: 'ENT', type: 'ordinal' });
          }
          break;
        case 'scatter': // Scatter
          this.yAxis = _.find(this.axisOptions, { type: 'linear' });
          this.xAxis = _.find(this.axisOptions, { slug: 'categories' });
          this.backupScatter = {
            xAxis: _.clone(this.xAxis),
            yAxis: _.clone(this.yAxis)
          };
          this.yAxis = {
            name: this.selectedQuestion.shortName,
            slug: this.selectedQuestion.shortName,
            type: 'ordinal'
          };
          this.groupedBy = 'SEXO';
          this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });

          this.xAxisOptions = this.axisOptions.filter(o => o).sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = [this.yAxis];

          if (this.secondVariables && this.secondVariables.length > 0) {
            this.selectedSecondQuestion = this.secondVariables[0];
            this.searchSecondQuestion.setValue(this.selectedSecondQuestion);
            this.xAxis = { name: this.selectedSecondQuestion.shortName, slug: this.selectedSecondQuestion.shortName, type: 'ordinal' };
          }

          if (this.selectedSecondQuestion) {
            this.dbService.getRowsFromQuestionId(this.selectedSecondQuestion.questionId)
              .subscribe(categories => {
                this.filterOptions.secondCategories = [ALL].concat(categories.map(c => c['name']) as string[]);
                this.selectedFilters['secondCategories'] = ALL;

              }, error => {
                const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                  panelClass: 'light-themed-dialog',
                  width: '400px',
                  data: {
                    error: error.error.message.toString() || error.statusText.toString() ||
                      error.message.toString() || error
                  }
                });
              });

            this.dbService.getColumnsFromQuestionId(this.selectedSecondQuestion.questionId)
              .subscribe(columns => {
                this.filterOptions.secondColumns = [ALL].concat(columns.map(c => c['name']) as string[]);
                this.selectedFilters['secondColumns'] = ALL;

              }, error => {
                const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                  panelClass: 'light-themed-dialog',
                  width: '400px',
                  data: {
                    error: error.error.message.toString() || error.statusText.toString() ||
                      error.message.toString() || error
                  }
                });
              });
          }

          break;
        case 'timeline': // Timeline
          this.xAxisOptions = this.axisOptions.filter(o => o.slug === 'year');
          this.yAxisOptions = this.axisOptions.filter(o => o.type === 'linear');
          this.xAxis = _.find(this.axisOptions, { slug: 'year' });
          this.yAxis = _.find(this.axisOptions, { slug: 'categories', type: 'linear' })
            || _.find(this.axisOptions, { slug: this.selectedQuestion.collapseBy });

          if (this.selectedQuestion && this.selectedQuestion.kind === 'columna') {
            if (this.selectedQuestion.kindAnswer !== 0) {
              this.selectedFilters['categories'] = this.filterOptions.categories[1] !== undefined ?
                this.filterOptions.categories[1] : ALL;
            }
            this.groupedBy = 'columns';
            this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
            this.selectedFilters['columns'] = ALL;
          } else {
            this.groupedBy = 'categories';
            this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
          }
          break;
        case 'map': // Map
          this.selectedFilters['ENT'] = NATIONAL;
          this.xAxisOptions = [{ slug: 'ENT', name: 'Unidad geográfica', type: 'ordinal' }];
          this.yAxisOptions = this.axisOptions.filter(o => o.type === 'linear');
          this.xAxis = _.find(this.xAxisOptions, { slug: 'ENT' });
          this.yAxis = _.find(this.axisOptions, { slug: 'categories', type: 'linear' })
            || _.find(this.axisOptions, { slug: this.selectedQuestion.collapseBy });
          // this.selectedFilters.year = ALL;
          this.groupedBy = '';
          break;
        default:
          this.xAxis = _.find(this.axisOptions, { slug: 'categories' });
          this.yAxis = _.find(this.axisOptions, { slug: 'RANGO_EDAD' });
          this.xAxisOptions = this.axisOptions.filter(o => o).sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(o => o).sort((a, b) => a.name < b.name ? -1 : 1);
          break;
      }
    }

    if (this.selectedQuestion && this.selectedQuestion.kind === 'columna' &&
      this.xAxis && this.xAxis.slug !== 'columns' && this.selectedChart !== 'timeline') {
      this.selectedFilters['columns'] = ALL;
      this.groupedBy = 'columns';
      this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
    }

    if (this.selectedChart === 'map') {
      const lastYear = this.filterOptions['year'].length - 1;
      this.selectedFilters['categories'] = this.filterOptions.categories[2] !== undefined ?
        this.filterOptions.categories[2] : ALL;
    }
    if (this.disabledXAxis) {
      this.disabledYAxis = !this.disabledYAxis;
      this.disabledXAxis = !this.disabledXAxis;
    }
  }

  /** Check that options for selected axes are valid */
  checkAxesSelected(): void {
    if (this.xAxis && this.xAxis.slug === 'categories') {
      this.xAxis.type = 'ordinal';
      if (this.selectedQuestion.kindAnswer === 1 && this.selectedChart !== 'heatmap'
        && this.selectedChart !== 'spineplot') {
        if (this.yAxis.type === 'ordinal') {
          this.xAxis.type = 'linear';
        } else {
          this.xAxis.type = 'ordinal';
        }
      } else if (this.selectedQuestion.kindAnswer === 2) {
        this.xAxis.type = 'linear';
      }
    }
    if (this.yAxis && this.yAxis.slug === 'categories') {
      this.yAxis.type = 'ordinal';
      if (this.selectedQuestion && this.selectedQuestion.kindAnswer === 1 && this.selectedChart !== 'heatmap'
        && this.selectedChart !== 'spineplot') {
        if (this.xAxis.type === 'ordinal') {
          this.yAxis.type = 'linear';
        } else {
          this.yAxis.type = 'ordinal';
        }
      } else if (this.selectedQuestion && this.selectedQuestion.kindAnswer === 2) {
        this.yAxis.type = 'linear';
      }
    }
    if (this.xAxis && this.xAxis.slug === this.selectedQuestion.collapseBy ||
      this.yAxis && this.yAxis.slug === this.selectedQuestion.collapseBy) {
      if (this.selectedFilters['unidad'] === 'Promedio') {
        this.selectedFilters['unidad'] = 'Porcentaje';
      }
    }

    /**
     * Set collapseBy column
     */
    switch (this.selectedChart) {
      case 'bars': // Bars
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis && this.yAxis.type === 'ordinal' && this.xAxis && this.xAxis.type === 'ordinal') {
          this.yAxis = _.find(this.axisOptions, { slug: 'categories', type: 'linear' })
            || _.find(this.axisOptions, { type: 'linear' });
        }
        if (this.yAxis && this.yAxis.type === 'linear' && this.xAxis && this.xAxis.type === 'linear') {
          this.xAxis = _.find(this.axisOptions, { type: 'ordinal' });
        }
        // d3.select('#ChangeSize').style('display', 'block');
        // d3.select('.label-drop-masmenos').style('display', 'block');
        break;
      case 'heatmap': // Heatmap
        if (this.yAxis.type === 'linear') {
          this.yAxis = _.find(this.axisOptions.reverse(), { type: 'ordinal' });
        }
        if (this.xAxis.type === 'linear') {
          if (this.xAxis.slug === 'categories' && this.selectedFilters['unidad'] !== 'Promedio') {
            this.xAxis.type = 'ordinal';
          } else {
            this.xAxis = _.find(this.axisOptions, { type: 'ordinal' });
          }
        }
        break;
      case 'spineplot': // Spineplot
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis.type === 'linear' && this.xAxis.type === 'linear') {
          this.xAxis = _.find(this.axisOptions, { slug: 'RANGO_EDAD' });
        }
        if (this.yAxis.type !== 'linear') {
          this.groupedBy = this.yAxis.slug;
          this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
        }
        break;
      case 'scatter': // Scatter
        break;
      case 'timeline': // Timeline
        this.xAxis = _.find(this.axisOptions, { slug: 'year' });
        if (this.yAxis.type !== 'linear') {
          this.yAxis = _.find(this.axisOptions, { type: 'linear' });
        }
        break;
      case 'map':
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        this.xAxis = _.find(this.xAxisOptions, { slug: 'ENT' });
        if (this.yAxis.type !== 'linear') {
          this.yAxis = _.find(this.axisOptions, { type: 'linear' });
        }
        break; // Map
      default:
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis.type === 'ordinal' && this.xAxis.type === 'ordinal') {
          this.yAxis = _.find(this.axisOptions, { type: 'linear' });
        }
        break;
    }

    const linearAxis = _.find([this.yAxis, this.xAxis], { 'type': 'linear' });
    this.collapseBy = linearAxis ? linearAxis :
      this.selectedFilters['unidad'] === 'Promedio' && this.selectedQuestion.kindAnswer !== 0 ?
        _.find(this.axisOptions, { slug: 'categories' }) : _.find(this.axisOptions, { type: 'linear' });
  }

  /** Validate filters, only two filters could be set each time */
  validateFilters(filters: {}): void {
    if (this.groupedBy && !_.includes([ALL, BOTH, NATIONAL], filters[this.groupedBy])) {
      this.groupedBy = '';
    }
    const values = Object.values(filters);
    const filtered = values.filter(o => !_.includes([ALL, BOTH, NATIONAL, 'Total', 'Porcentaje', 'Promedio'], o));

    if (filtered.length > 2) {
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: 'No es posible seleccionar más de dos filtros, por favor cambia tu selección'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  /** Called when filters were updated from panel (on submit) */
  updateFilters(filters: {}): void {
    this.showFilters = false;
    if (this.groupedBy && !_.includes([ALL, BOTH, NATIONAL], filters[this.groupedBy])) {
      this.groupedBy = '';
    }
    const values = Object.values(filters);
    const filtered = values.filter(o => !_.includes([ALL, BOTH, NATIONAL, 'Total', 'Porcentaje', 'Promedio'], o));

    if (filtered.length > 2) {
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: 'No es posible seleccionar más de dos filtros, por favor cambia tu selección'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    } else {
      setTimeout(() => {
        this.updateChart();
      }, 100);
    }
  }

  /**
   * Get initial options from selected question
   */
  setOptions() {
    // Set filterOptions
    this.filterOptions = {
      unidad: ['Total', 'Porcentaje'],
      categories: [],
      columns: [],
      secondCategories: [],
      secondColumns: []
    };
    this.selectedFilters = {};

    // Get columns
    const obsColumns = this.dbService.getColumnsFromQuestionId(this.selectedQuestion.questionId);
    const obsCategories = this.dbService.getRowsFromQuestionId(this.selectedQuestion.questionId);

    forkJoin(obsColumns, obsCategories).subscribe(res => {
      this.filterOptions.columns = [ALL].concat(_.uniq(res[0].map(o => o['name'])
        .sort(this.sortAll)));
      this.filterOptions.categories = [ALL].concat(_.uniq(res[1].map(o => o['name'])
        .sort(this.sortAll)));

      if (this.selectedQuestion.fieldOptions) {
        _.forEach(this.selectedQuestion.fieldOptions, function (fo) {
          const filterAbv = fo['slug'];
          let dbOpts;
          let completeOpts;

          dbOpts = _.uniq(fo['options'].map(d => d['name']).sort(this.sortAll));

          if (filterAbv === 'SEXO') {
            completeOpts = [BOTH].concat(dbOpts as string[]);
          } else if (filterAbv === 'ENT') {
            completeOpts = [NATIONAL].concat(dbOpts as string[]);
          } else {
            completeOpts = [ALL].concat(dbOpts as string[]);
            // Remove NA from filter for COLOR_PIEL
            if (filterAbv === 'COLOR_PIEL') {
              completeOpts = completeOpts.filter(e => e !== 'NA');
            }
          }

          this.filterOptions[filterAbv] = completeOpts;
        }.bind(this));
      }

      if (this.selectedQuestion.kindAnswer !== 0) {
        this.filterOptions.unidad.push('Promedio');
      }

      this.collapseBy = this.selectedQuestion.kindAnswer === 0 ?
        this.axisOptions.find(o => o.slug === this.selectedQuestion.collapseBy) :
        this.axisOptions.find(o => o.slug === 'categories');

      this.generateSelectedFilters();
      this.setAxisOptions();

      if (this.selectedQuestion.kindAnswer !== 0) {
        this.selectedFilters['unidad'] = 'Promedio';
        const idx = _.findIndex(this.axisOptions, o => o.slug === 'categories');
        this.axisOptions[idx]['type'] = 'linear';
      } else {
        this.selectedFilters['unidad'] = 'Porcentaje';
      }

      this.generateGroupItems();
      this.setDefaultAxes();
      this.showFilterPopup();
    }, err => {
      console.error(err);
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: err.error.message.toString() || err.statusText.toString()
        }
      });
    });
  }

  /** Sort data based on some characteristics' order */
  sortAll(a: any, b: any) {
    const res = ['Sí', 'No'];

    const ages = [
      '0 a 5 años',
      '6 a 11 años',
      '9 a 11 años',
      '12 a 17 años',
      '18 a 29 años',
      '30 a 59 años',
      '60 o más años'
    ];

    const situation = [
      'Siempre',
      'Algunas veces',
      'Pocas veces',
      'Nunca',
      'No responde'];

    const education = [
      'Sin escolaridad',
      'Hasta primaria incompleta',
      'Primaria completa',
      'Secundaria completa',
      'Media superior',
      'Superior',
      'No especificado'];

    const frequency = [
      'Mucho',
      'Algo',
      'Poco',
      'Nada',
      'No Sabe',
      'No aplica'];

    const quantity = [
      'Mucha',
      'Alguna',
      'Poca',
      'Nada',
      'No sabe'];

    const estrato = [
      'Alto',
      'Medio alto',
      'Medio bajo',
      'Bajo'];

    const skinColor = [
      'Más obscuro',
      'Intermedio',
      'Más claro'];

    if (_.includes(ages, a) && _.includes(ages, b)) {
      return ages.indexOf(a) - ages.indexOf(b);
    } else if (_.includes(situation, a) && _.includes(situation, b)) {
      return situation.indexOf(a) - situation.indexOf(b);
    } else if (_.includes(education, a) && _.includes(education, b)) {
      return education.indexOf(a) - education.indexOf(b);
    } else if (_.includes(frequency, a) && _.includes(frequency, b)) {
      return frequency.indexOf(a) - frequency.indexOf(b);
    } else if (_.includes(quantity, a) && _.includes(quantity, b)) {
      return quantity.indexOf(a) - quantity.indexOf(b);
    } else if (_.includes(res, a) && _.includes(res, b)) {
      return res.indexOf(a) - res.indexOf(b);
    } else if (_.includes(estrato, a) && _.includes(estrato, b)) {
      return estrato.indexOf(a) - estrato.indexOf(b);
    } else if (_.includes(skinColor, a) && _.includes(skinColor, b)) {
      return skinColor.indexOf(a) - skinColor.indexOf(b);
    } else if (a === 'Otro' || a === 'No sabe' || a === 'No aplica') {
      return 1;
    } else if (b === 'Otro' || b === 'No sabe' || b === 'No aplica') {
      return -1;
    } else {
      if (!Number.isNaN(+a) && !Number.isNaN(+b)) {
        // If both values are numbers use numeric value
        return Number(a) - Number(b);
      } else if (!Number.isNaN(+a) && Number.isNaN(+b)) {
        return -1;
      } else if (Number.isNaN(+a) && !Number.isNaN(+b)) {
        return 1;
      } else if (a <= b) {
        return -1;
      } else {
        return 1;
      }
    }
  }

  /** Set axis options available for the question */
  setAxisOptions() {
    const collapseBy = this.selectedGroupName ? this.selectedGroupName.collapseBy : this.selectedQuestion.collapseBy;

    this.axisOptions = [
      { name: 'Cantidad de personas', slug: collapseBy, type: 'linear' },
      { name: 'Grupo de edad', slug: 'RANGO_EDAD', type: 'ordinal' },
      { name: 'Sexo', slug: 'SEXO', type: 'ordinal' },
      { name: 'Estrato socioeconómico', slug: 'ESTRATO', type: 'ordinal' },
      { name: 'Tamaño de localidad', slug: 'TAM_LOC', type: 'ordinal' }
    ];

    if (this.selectedQuestion && this.selectedGroupName && this.selectedGroupName.slug === 'Cuestionario de opiniones y experiencias' &&
      this.selectedQuestion.subtopic === 'Prácticas y experiencias de discriminación') {
      this.axisOptions.push({ name: 'Tono de piel', slug: 'COLOR_PIEL', type: 'ordinal' });
    } else if (this.selectedQuestion && this.selectedGroupName && this.selectedGroupName.slug === 'Características sociodemográficas') {
      this.axisOptions.push({ name: 'Tono de piel', slug: 'COLOR_PIEL', type: 'ordinal' });
    } else if (this.selectedQuestion && this.selectedQuestion.subtopic === 'Características sociodemográficas') {
      this.axisOptions.push({ name: 'Tono de piel', slug: 'COLOR_PIEL', type: 'ordinal' });
    }
    if (this.selectedQuestion && this.selectedGroup === 'Cuestionario de opiniones y experiencias') {
      this.axisOptions.push({ name: 'Entidad federativa', slug: 'ENT', type: 'ordinal' });
    }
    if (this.selectedQuestion.kind === 'columna') {
      this.axisOptions.push({ name: this.selectedQuestion.categoryName, slug: 'columns', type: 'ordinal' });
      this.axisOptions.push({ name: this.selectedQuestion.subcategoryName, slug: 'categories', type: 'ordinal' });
    } else if (this.selectedQuestion.kind === 'fila') {
      this.axisOptions.push({
        name: this.selectedQuestion.categoryName || this.selectedQuestion.shortName,
        slug: 'categories', type: 'ordinal'
      });
    }
  }

  /**
   * Sets the selected groupBy in the drowpdown
   */
  selectXAxisGroupBy(xAxisGroupBy) {
    this.xAxisGroupBy = xAxisGroupBy;
    this.groupBy(this.xAxisGroupBy.slug);
  }

  /** Called on selectXAxisGroupBy changes */
  onSelectXAxisGroupBy() {
    this.selectXAxisGroupBy(this.xAxisGroupBy);
  }

  /** Called when groupby was changed */
  groupBy(item) {
    if (!((this.xAxis && item === this.xAxis.slug) || ((this.yAxis && item === this.yAxis.slug) && this.selectedChart === 'bars'))) {
      this.groupedBy = item;
      if (item) {
        this.selectedFilters[item] = this.filterOptions[item][0];
      }
    }
    if (this.selectedChart === 'heatmap') { // Heatmap
      if (item) {
        this.yAxis = _.find(this.yAxisOptions, { slug: this.groupedBy });
      } else {
        this.yAxis = _.find(this.yAxisOptions, { type: 'ordinal' });
        this.groupedBy = this.yAxis.slug;
      }
    }
    if (this.selectedChart === 'spineplot') { // Spineplot
      if (item) {
        this.yAxis = _.find(this.yAxisOptions, { slug: this.groupedBy });
      } else {
        this.yAxis = _.clone(this.collapseBy);
      }
    }
    if (this.selectedChart === 'map') {
      this.groupedBy = '';
    }
    this.showFilterPopup();
  }

  /** Update chart */
  updateChart() {
    const vm = this;
    this.updateUrl();
    this.generatedTitle = this.generateTitle();
    // Show loading text while updating chart
    d3.select('.empty-chart').selectAll('*').remove();
    d3.selectAll('.d3-tip').remove();
    d3.selectAll('.title-tip').remove();
    d3.select('.empty-chart').text('CARGANDO GRÁFICA...');
    if (this.selectedChart && this.selectedQuestion && this.xAxis && this.yAxis) {
      this.checkAxesSelected();
      this.generateNamedFilters();
      /**
       * redraw selected chart
       * Get data to draw chart
       */
      const selectedFilters = _.cloneDeep(this.selectedFilters);
      const xAxis = this.xAxis.slug;
      let expFactor = this.selectedGroupName ? this.selectedGroupName.collapseBy : this.selectedQuestion.collapseBy;
      let yAxis = this.yAxis.slug === this.selectedQuestion.collapseBy ? expFactor : this.yAxis.slug;
      let groupedBy = this.groupedBy + '';
      const collapseBy = this.collapseBy.slug;
      const project = {};
      if (this.selectedQuestion.comment) {
        this.comment = this.selectedQuestion.comment;
      } else {
        this.comment = '';
      }
      if (this.selectedChart === 'bars') {
        if (this.yAxis.type === 'ordinal') {
          this.xAxisOptions[0].name = `${this.selectedFilters['unidad']} de personas`;
        } else {
          this.yAxisOptions[0].name = `${this.selectedFilters['unidad']} de personas`;
        }
      }
      if ((this.selectedChart === 'scatter' || this.selectedChart === 'heatmap') && groupedBy) { // Scatter
        project[groupedBy] = 1;
        groupedBy = '';
      }
      if (this.selectedChart === 'spineplot') { // Spineplot
        yAxis = this.collapseBy.slug;
      }
      const keys = {
        xAxis: xAxis,
        yAxis: yAxis,
        groupBy: groupedBy,
        project: project,
        collapseBy: collapseBy,
        expFactor: expFactor
      };

      if (this.selectedChart === 'map') { // Map
        this.generateSelectedFilters();

        const filters = Object.keys(this.selectedFilters);
        const values = Object.values(this.selectedFilters);
        const filteredValues = values.filter(function (obj) {
          return !_.includes([ALL, BOTH, NATIONAL, 'Total', 'Porcentaje', 'Promedio'], obj);
        });
        for (let index = 0; index < filteredValues.length; index++) {
          const element = filteredValues[index];
          const idx = values.indexOf(element);
          keys.project[filters[idx]] = 1;
        }
      }

      if (this.selectedChart !== 'scatter') {
        if (this.selectedGroupName) {
          selectedFilters[this.selectedGroupName.dummy] = 1;
        }
        if (this.selectedQuestion['relativePercentage']) {
          keys['relativePercentage'] = true;
        }
        this.loadingData = true;
        this.progress = setInterval(function () {
          if (vm.counter < 92) {
            vm.counter += Math.floor(Math.random() * (5 - 0 + 1)) + 0;
          }
        }, 600);
        this.dbService.getDataToDraw(this.selectedQuestion.questionId, selectedFilters, keys)
          .subscribe(dataToDraw => {
            d3.select('.empty-chart')
              .style('border', null)
              .text('');
            if (dataToDraw.length === 0) {
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: 'No existen datos para esta pregunta'
                }
              });
              dialogRef.afterClosed().subscribe(result => {
                d3.select('.empty-chart')
                  .style('border', 'dashed 2px #ccc')
                  .text('NO EXISTEN DATOS PARA ESTA PREGUNTA');
              });
            }
            // Remove NA for 'COLOR_PIEL'
            if (dataToDraw[0].hasOwnProperty('COLOR_PIEL')) {
              dataToDraw = dataToDraw.filter(e => e['COLOR_PIEL'] !== 'NA');
            }

            this.dataToDraw = dataToDraw;

            /** Get groupByOptions */
            if (this.filterOptions[this.groupedBy]) {
              this.groupByOptions = this.filterOptions[this.groupedBy].filter(o => o !== ALL && o !== BOTH && o !== NATIONAL);
            }

            this.sortChanged('names');
            clearInterval(this.progress);
            this.counter = 0;
            this.loadingData = false;
            this.startJoyride();
          }, error => {
            console.error(error);
            const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
              panelClass: 'light-themed-dialog',
              width: '400px',
              data: {
                error: error.error.message.toString() || error.statusText.toString() ||
                  error.message.toString() || error
              }
            });
            dialogRef.afterClosed().subscribe(result => {
              clearInterval(this.progress);
              this.counter = 0;
              this.loadingData = false;
              this.router.navigate(['/content/enadis/explore'], {
                queryParams: {}
              });
            });
          });
      } else {
        if (this.selectedSecondQuestion && this.selectedQuestion) {
          if (this.selectedQuestion.topic === 'Características de la vivienda' &&
            this.selectedSecondQuestion && this.selectedSecondQuestion.topic === 'Características de los hogares') {
            expFactor = 'FACTOR_HOG';
          }
          if (this.selectedSecondQuestion.topic === 'Características sociodemográficas' &&
            _.includes(['Características de la vivienda', 'Características de los hogares'], this.selectedQuestion.topic)) {
            expFactor = 'FACTOR_SDE';
          }
          if (_.includes([
            'Características sociodemográficas',
            'Características de los hogares',
            'Características de la vivienda'], this.selectedSecondQuestion.topic)) {
            expFactor = this.selectedSecondQuestion.collapseBy;
          }
          this.collapseBy = {
            name: 'Total', slug: this.selectedQuestion && this.selectedQuestion.kindAnswer !== 0 &&
              this.collapseBy ? this.collapseBy.slug : expFactor, type: 'linear'
          };

          const firstFilters = _.cloneDeep(selectedFilters);
          delete firstFilters['secondCategories'];
          delete firstFilters['secondColumns'];

          const firstQuestion = {
            'keys': {
              'xAxis': 'categories',
              'yAxis': expFactor,
              'groupBy': groupedBy,
              'collapseBy': expFactor,
              'expFactor': expFactor,
              'project': project
            },
            'questionId': this.selectedQuestion.questionId,
            'selectedFilters': firstFilters
          };

          selectedFilters['columns'] = this.selectedFilters['secondColumns'] || ALL;
          selectedFilters['categories'] = this.selectedFilters['secondCategories'] || ALL;

          delete selectedFilters['secondCategories'];
          delete selectedFilters['secondColumns'];

          const secondQuestion = {
            'keys': {
              'xAxis': 'categories',
              'yAxis': expFactor,
              'groupBy': groupedBy,
              'collapseBy': expFactor,
              'expFactor': expFactor,
              'project': project
            },
            'questionId': this.selectedSecondQuestion.questionId,
            'selectedFilters': selectedFilters
          };
          this.loadingData = true;
          /**
           * Expression has changed after it was checked. Previous value: 'ngIf: false'. Current value: 'ngIf: true'.
           */
          this.progress = setInterval(function () {
            if (vm.counter < 92) {
              vm.counter += Math.floor(Math.random() * (5 - 0 + 1)) + 0;
            }
          }, 600);
          this.dbService.crossData(firstQuestion, secondQuestion)
            .subscribe(dataToDraw => {
              d3.select('.empty-chart')
                .style('border', null)
                .text('');
              if (dataToDraw.length === 0) {
                const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                  panelClass: 'light-themed-dialog',
                  width: '400px',
                  data: {
                    error: 'No existen datos para este cruce, cambia la segunda variable'
                  }
                });
                dialogRef.afterClosed().subscribe(result => {
                  d3.select('.empty-chart')
                    .style('border', 'dashed 2px #ccc')
                    .text('NO EXISTEN DATOS PARA ESTE CRUCE, CAMBIA LA SEGUNDA VARIABLE');
                });
              }

              /**
               * Get groupByOptions
               */
              if (this.filterOptions[this.groupedBy]) {
                this.groupByOptions = this.filterOptions[this.groupedBy].filter(o => o !== ALL && o !== BOTH && o !== NATIONAL);
              }
              this.xAxis = { name: this.selectedSecondQuestion.shortName, slug: this.selectedSecondQuestion.shortName, type: 'ordinal' };
              this.yAxis = { name: this.selectedQuestion.shortName, slug: this.selectedQuestion.shortName, type: 'ordinal' };

              this.dataToDraw = dataToDraw;

              this.sortChanged('names');
              clearInterval(this.progress);
              this.loadingData = false;
              this.counter = 0;
            }, error => {
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: error.error ? error.error.message.toString() : (error.statusText.toString() ||
                    error.message.toString() || error)
                }
              });
              dialogRef.afterClosed().subscribe(result => {
                clearInterval(this.progress);
                this.counter = 0;
                this.loadingData = false;
                this.router.navigate(['/content/enadis/explore'], {
                  queryParams: {}
                });
              });
            });
        }
      }
    }
  }

  /** Start joyride tour */
  startJoyride() {
    if (!this.storage.get('joyrideDone')) {
      this.joyrideService.startTour(
        {
          steps: ['step1', 'step2', 'step4'],
          stepDefaultPosition: 'top',
        } // Your steps order
      ).subscribe(
        (step) => {
          // Do something
          d3.select('.joyride-step__next-container .joyride-button')
            .text('Siguiente');
          d3.select('.joyride-step__prev-container .joyride-button')
            .text('Anterior');
          d3.select('.joyride-step__done-button .joyride-button')
            .text('Terminar');
        },
        (error) => { /*handle error*/ },
        () => {
          /*Tour is finished here */
          this.storage.set('joyrideDone', true);
        }
      );
    }
  }

  /**
   * Triggered by app-question-dropdown-selection change
   * @param question Question from ngModelChange
   */
  onChangeQuestion(config: { selectedQuestion: Question, selectedGroup: any }) {
    this.selectedQuestion = config.selectedQuestion;
    this.collapseBy.slug = config.selectedGroup;
    this.selectedGroupName = this.dbService.findGroup(config.selectedGroup);
    this.setOptions();
  }

  /** Update url to share */
  updateUrl() {
    const urlTree = this.router.createUrlTree(['/content/enadis/explore/' + this.selectedQuestion.questionId], {
      queryParams: {
        chart: this.selectedChart,
        mode: this.variableAutocompleteConfig.mode,
        selectedTopic: this.selectedGroupName.slug,
        selectedSubtopic: this.variableAutocompleteConfig.selectedSubtopic
      },
      queryParamsHandling: 'merge',
      preserveFragment: true
    }).toString();
    this.location.go(urlTree);
  }

  /** Parse data got from request. Filter sort and adapt to each chart. */
  parseData(data: Entry[], considerLegendOptions?: boolean): Entry[] {
    const vm = this;
    /**
     * Sort data by this.orderBy
     */
    if (this.filterOptions[this.orderBy]) {
      this.showOrderBy = this.filterOptions[this.orderBy].length > 2 ? true : false;
    }
    if (this.selectedQuestion.relativePercentage && this.xAxis.slug === 'categories') {
      this.showOrderBy = false;
    }
    let resultData = _.cloneDeep(data).sort(function (a, b) {
      if (_.includes(this.filterOptions[this.orderBy], a[this.orderBy]) && _.includes(this.filterOptions[this.orderBy], b[this.orderBy])) {
        const res = ['No', 'Sí'];
        return this.filterOptions[this.orderBy].indexOf(a[this.orderBy]) - this.filterOptions[this.orderBy].indexOf(b[this.orderBy]);
      } else if (a[this.orderBy] === 'Otro' || a[this.orderBy] === 'No aplica') {
        return 1;
      } else if (b[this.orderBy] === 'Otro' || b[this.orderBy] === 'No aplica') {
        return -1;
      } else {
        if (this.sortBy.valuesAscending === true) {
          if (this.groupedBy && this.groupedBy !== this.xAxis.slug) {
            const firstValue = this.filterOptions[this.groupedBy][1] || 'totalByGroup';
            return Number(a[firstValue]) - Number(b[firstValue]);
          } else if (!Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            // If both values are numbers use numeric value
            return Number(a[this.orderBy]) - Number(b[this.orderBy]);
          } else if (!Number.isNaN(+a[this.orderBy]) && Number.isNaN(+b[this.orderBy])) {
            return -1;
          } else if (Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            return 1;
          } else if (a[this.orderBy] <= b[this.orderBy]) {
            return -1;
          } else {
            return 1;
          }
        } else if (this.sortBy.valuesDescending === true) {
          if (this.groupedBy && this.groupedBy !== this.xAxis.slug) {
            const firstValue = this.filterOptions[this.groupedBy][1] || 'totalByGroup';
            return Number(b[firstValue]) - Number(a[firstValue]);
          } else if (!Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            // If both values are numbers use numeric value
            return Number(b[this.orderBy]) - Number(a[this.orderBy]);
          } else if (!Number.isNaN(+a[this.orderBy]) && Number.isNaN(+b[this.orderBy])) {
            return 1;
          } else if (Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            return -1;
          } else if (a[this.orderBy] <= b[this.orderBy]) {
            return 1;
          } else {
            return -1;
          }
        }
      }
    }.bind(this)).filter(function (d) {
      return (!this.xAxis || this.xAxis && !this.filterOptions[this.xAxis.slug] || this.xAxis && this.xAxis.type === 'linear' ||
        this.xAxis && _.includes(this.filterOptions[this.xAxis.slug].map(o => o + ''), d[this.xAxis.slug] + '')
        || this.selectedFilters.ENT === NATIONAL) &&
        (!this.yAxis || this.yAxis && !this.filterOptions[this.yAxis.slug] || this.yAxis && this.yAxis.type === 'linear' || this.yAxis &&
          _.includes(this.filterOptions[this.yAxis.slug].map(o => o + ''), d[this.yAxis.slug] + '')) ||
        this.yAxis && (this.groupedBy && this.yAxis.slug === this.groupedBy);
    }.bind(this));

    /**
     * Adapt data for each chart
     */
    const collapseBy = this.collapseBy.slug;
    switch (this.selectedChart) {
      case 'bars':
        if ((this.xAxis && this.xAxis.slug === 'categories' && this.xAxis.type === 'linear') ||
          (this.yAxis && this.yAxis.slug === 'categories' && this.yAxis.type === 'linear')) {

          resultData = resultData.filter(function (d) {
            if (d.year) {
              d.year += '';
            }
            return !Number.isNaN(d['categories']);
          });
        } else {
          resultData = resultData.map(function (d) {
            d.year += '';
            return d;
          });
        }
        resultData = resultData.map(function (obj) {
          // If spineplot is grouped by municipality
          if (this.groupedBy === 'ENT' && obj['ENT'] === 'Fuera AMM') {
            obj['ENT'] = 'Fuera del Área Metropolitana de Monterrey';
          }
          return obj;
        }.bind(this));
        break;
      case 'heatmap': // Heatmap
        resultData = resultData.map(function (d) {
          if (d.year) {
            d.year += '';
          }
          // If heatmap is grouped by municipality
          if (this.groupedBy === 'ENT' && d['ENT'] === 'Fuera AMM') {
            d['ENT'] = 'Fuera del Área Metropolitana de Monterrey';
          }
          return d;
        }.bind(this));
        break;
      case 'spineplot': // Spineplot
        resultData = resultData.map(function (obj) {
          if (obj.year) {
            obj.year += '';
          }
          // If spineplot is grouped by municipality
          if (this.groupedBy === 'ENT' && obj['ENT'] === 'Fuera AMM') {
            obj['ENT'] = 'Fuera del Área Metropolitana de Monterrey';
          }
          return obj;
        }.bind(this));
        if (this.selectedFilters['unidad'] === 'Porcentaje') {
          // Calculating representative percentage of the expansion factor
          _.forEach(resultData, function (element) {
            element[collapseBy] = (element.totalByGroup / _.sumBy(resultData, 'totalByGroup')) * 100;
          });
        }
        break;
      case 'timeline': // Timeline
        // Parse year as date
        resultData = resultData.map(function (d) {
          d.year = ('' + d.year).slice(0, 4) + '-01-01';
          return d;
        });
        break;
      case 'map': // Map
        const filters = Object.keys(this.selectedFilters).filter(o => o !== 'unidad' && o !== 'ENT');
        const totals = {};
        _.uniq(resultData.map(o => o.ENT) as string[]).forEach(function (mpo) {
          totals[mpo] = d3.sum(resultData.filter(o => o.ENT === mpo), function (o) {
            return o[collapseBy];
          });
        });

        resultData = resultData.filter(function (obj) {
          obj.total = totals[obj.ENT];
          let result = true;
          filters.forEach(function (key) {
            if (obj[key] && this.selectedFilters[key] && this.collapseBy.slug !== key) {
              result = result && obj[key] === this.selectedFilters[key];
            }
          }.bind(this));
          return result;
        }.bind(this));

        let newData = [];
        const GeoUnits = this.filterOptions['ENT'].map(g => g.toUpperCase().replace('Á', 'A').replace('Í', 'I'));

        const NuevoLeon = this.selectedFilters['unidad'] === 'Promedio' ?
          d3.sum(resultData, o => o[collapseBy] * o.factor_expansion) / d3.sum(resultData, o => o.factor_expansion) :
          d3.sum(resultData, o => o[collapseBy]);
        const NuevoLeonTotal = d3.sum(resultData, o => o.total);
        const AMM = this.selectedFilters['unidad'] === 'Promedio' ?
          d3.sum(resultData.filter(o => o.ENT !== 'Fuera AMM'), o => o[collapseBy] * o.factor_expansion) /
          d3.sum(resultData.filter(o => o.ENT !== 'Fuera AMM'), o => o.factor_expansion) :
          d3.sum(resultData.filter(o => o.ENT !== 'Fuera AMM'), o => o[collapseBy]);
        const AMMTotal = d3.sum(resultData.filter(o => o.ENT !== 'Fuera AMM'), o => o.total);
        const FAMM = this.selectedFilters['unidad'] === 'Promedio' ?
          d3.sum(resultData.filter(o => o.ENT === 'Fuera AMM'), o => o[collapseBy] * o.factor_expansion) /
          d3.sum(resultData.filter(o => o.ENT === 'Fuera AMM'), o => o.factor_expansion) :
          d3.sum(resultData.filter(o => o.ENT === 'Fuera AMM'), o => o[collapseBy]);
        const FAMMTotal = d3.sum(resultData.filter(o => o.ENT === 'Fuera AMM'), o => o.total);

        const Muns = resultData.filter(function (obj) {
          return _.includes(GeoUnits, obj.ENT.toUpperCase().replace('Á', 'A').replace('Í', 'I'));
        }).map(function (obj) {
          obj.id = this.municipalitiesIds[obj.ENT];
          obj.name = obj.ENT;
          return obj;
        }.bind(this));

        const NUEVOLEON = { id: 18, name: NATIONAL, total: NuevoLeonTotal };
        NUEVOLEON[collapseBy] = NuevoLeon;
        newData.push(NUEVOLEON);
        const AMMObj = { id: 1, name: 'Área Metropolitana de Monterrey', total: AMMTotal };
        AMMObj[collapseBy] = AMM;
        newData.push(AMMObj);
        const FUERAAMM = { id: 0, name: 'Fuera del Área Metropolitana de Monterrey', total: FAMMTotal };
        FUERAAMM[collapseBy] = FAMM;
        newData.push(FUERAAMM);
        newData = newData.concat(Muns);
        resultData = newData;
        break;
      default:
        resultData = resultData;
        break;
    }

    /**
     * If data is grouped by ENT, calculate missing data
     */
    if (this.groupedBy === 'ENT') {
      for (let index = 0; index < resultData.length; index++) {
        const element = resultData[index];
        element['Fuera del Área Metropolitana de Monterrey'] = element['Fuera AMM'];
        const groupedElements = _.toPairs(element).filter(function (o) {
          return _.includes(this.filterOptions['ENT'], o[0]);
        }.bind(this));
        if (this.selectedFilters['unidad'] === 'Promedio') {
          element['Área Metropolitana de Monterrey'] = d3.mean(groupedElements.filter(
            o => o[0] !== 'Fuera del Área Metropolitana de Monterrey'), o => o[1]);
          element[NATIONAL] = d3.mean(groupedElements, o => o[1]);
        } else {
          element['Área Metropolitana de Monterrey'] = d3.sum(groupedElements.filter(
            o => o[0] !== 'Fuera del Área Metropolitana de Monterrey'), o => o[1]);
          element[NATIONAL] = d3.sum(groupedElements, o => o[1]);
        }
      }
    }

    /**
     * Filter data by legend options active
     */
    resultData = resultData.filter(function (d) {
      if (considerLegendOptions) {
        if (this.selectedChart === 'map') {
          return this.legendOptions.filter(o => o.active).map(o => o.id).includes(d.id);
        } else {
          let slug = '';
          if ( this.groupedBy && this.groupedBy !== this.xAxis.slug ) {
            if (this.selectedChart === 'scatter') { // Scatter
              slug = this.groupedBy;
            }
            const unCheckedNames = this.legendOptions.filter(o => !o.active).map(o => o.name);
            for (let index = 0; index < unCheckedNames.length; index++) {
              const name = unCheckedNames[index];
              delete d[name];
            }
            if (this.legendOptions[0] !== 'Total') {
              this.groupByOptions = this.legendOptions.filter(o => o.active).map(o => o.name + '');
            }
          } else if (this.legendTitle === this.xAxis.name && !(this.xAxis.slug === 'year' && this.selectedChart === 'timeline')) {
            slug = this.xAxis.slug;
          } else if (this.legendTitle === this.yAxis.name) {
            slug = this.yAxis.slug;
          }

          return !slug || this.legendOptions.filter(o => o.active).map(o => o.name + '').includes(d[slug] + '');
        }
      } else {
        return true;
      }
    }.bind(this));

    return resultData;
  }

  /** Set legend options as active or not for each checkbox */
  setLegendOptions(dataToDraw: Entry[]): void {
    const vm = this;
    // legendOptions by xAxis
    let slug = this.xAxis.slug;
    if (this.yAxis.type === 'ordinal') {
      slug = this.yAxis.slug;
    }
    if (this.groupedBy) {
      slug = this.groupedBy;
    }
    if (this.selectedFilters[this.xAxis.slug] && !_.includes([ALL, BOTH, NATIONAL], this.selectedFilters[this.xAxis.slug])) {
      this.legendOptions = [this.selectedFilters[this.xAxis.slug]].map(function (c) {
        return { name: c, active: true };
      });
    } else if (this.filterOptions[this.xAxis.slug] && this.filterOptions[this.xAxis.slug].length > 0) {
      this.legendOptions = _.uniq(this.filterOptions[this.xAxis.slug].filter(o => o !== ALL && o !== BOTH)).map(function (c) {
        return { name: c, active: true };
      });
    } else {
      this.legendOptions = _.uniq(this.dataToDraw.map(function (o) { return o[this.xAxis.slug]; }.bind(this))
        .filter(o => o !== ALL && o !== BOTH)).map(function (c) {
          return { name: c, active: true };
        });
    }
    this.legendTitle = this.xAxis.name;

    // legendOptions by groupedBy
    if (this.groupedBy && !_.includes([ALL, BOTH, NATIONAL], this.selectedFilters[this.groupedBy])) {
      this.legendOptions = [this.selectedFilters[this.groupedBy]].map(function (c) {
        return { name: c, active: true };
      });
    } else if (this.groupedBy) {
      this.legendOptions = _.uniq(this.filterOptions[this.groupedBy].filter(o => o !== ALL && o !== BOTH)).map(function (c) {
        return { name: c, active: true };
      });
      const foundAxis = _.find(this.axisOptions, { 'slug': this.groupedBy });
      this.legendTitle = foundAxis && this.groupedBy !== 'ENT' ? foundAxis['name'] : 'Unidad geográfica';
    } else if (this.yAxis && this.yAxis.type === 'ordinal') {
      // legendOptions by yAxis
      if (this.selectedFilters[this.yAxis.slug] && !_.includes([ALL, BOTH, NATIONAL], this.selectedFilters[this.yAxis.slug])) {
        this.legendOptions = [this.selectedFilters[this.yAxis.slug]].map(function (c) {
          return { name: c, active: true };
        });
      } else {
        this.legendOptions = _.uniq(dataToDraw.map(function (o) { return o[this.yAxis.slug]; }.bind(this))).map(function (c) {
          return { name: c, active: true };
        });
      }
      this.legendTitle = this.yAxis.name;
    }
    if (this.selectedChart === 'map') {
      // Get only municipalities that currently exist on data
      this.legendOptions = _.uniqBy(this.dataToDraw.filter(o => o.ENT !== 'Fuera AMM')
        .map(function (obj) {
          const key = obj.ENT;
          return {
            name: key,
            id: this.municipalitiesIds[key],
            active: true
          };
        }.bind(this)), 'id');
      this.legendOptions.unshift({ name: 'Fuera del Área Metropolitana de Monterrey', id: 0, active: true });
      this.legendOptions.unshift({ name: 'Área Metropolitana de Monterrey', id: 1, active: true });
      this.legendOptions.unshift({ name: NATIONAL, id: 18, active: true });
      this.legendTitle = 'UNIDAD GEOGRÁFICA';
    }
    // Filter legendOptions based on dataToDraw
    if (this.dataToDraw && this.dataToDraw.length > 0) {
      if (this.groupedBy === '') {
        this.legendOptions = this.legendOptions.filter(o => {
          // Check if value is set in property
          return _.includes(vm.dataToDraw.map(d => d[slug]), o.name);
        });
      } else {
        this.legendOptions = this.legendOptions.filter(o => {
          // Keep keys from all objects
          return _.includes(vm.dataToDraw.reduce((keys, obj) => _.uniq(keys.concat(Object.keys(obj))), []), o.name);
        });
      }
    }
    this.colorCheckboxes();
  }

  /** Color checkboxes from legend */
  colorCheckboxes(): void {
    let colors = this.colors;
    if (colors.length > this.legendOptions.length) {
      colors = this.colors.slice(0, this.legendOptions.length).reverse();
    }
    setTimeout(function () {
      const selection = d3.selectAll('.checkbox-layout-tablet .mat-checkbox-background');
      if (selection.nodes().length > 0) {
        selection
          .style('background-color', function (d, i) {
            return colors[i % colors.length];
          }.bind(this));
      }
    }.bind(this), 0);
  }

  /**
   * Draw chart, only SVG DOM operations
   * @param dataToDraw Filtered data to be drawn
   */
  drawChart(dataToDraw: Entry[]): void {
    const considerLegendOptions = true;
    this.filteredData = this.parseData(dataToDraw, considerLegendOptions);
    d3.select('.empty-chart').style('border', null);
  }

  /**
   * Change selected chart
   * @param index - Index from 1 to 6 of current chart selected
   */
  selectChart(chartName: string) {
    this.selectedChart = chartName;
    this.disabledXAxis = false;
    this.disabledYAxis = this.selectedChart === 'bars' ? true : false;
    this.setColorPalette();
    this.setDefaultAxes();
    this.showFilterPopup();
  }

  /** Toggle display share options */
  toggleShareOptions(showPanel) {
    this.sharePage = showPanel;
  }

  /** Called qhen sort option has changed */
  sortChanged(prop) {
    const ordinalAxis = _.findIndex([this.xAxis, this.yAxis], o => o.type === 'ordinal');
    if (prop === 'names') {
      this.sortBy.names = true;
      this.sortBy.valuesAscending = false;
      this.sortBy.valuesDescending = false;
      this.orderBy = ordinalAxis === 1 ? this.yAxis.slug : this.xAxis.slug;
    } else if (prop === 'valuesAscending') {
      this.sortBy.names = false;
      this.sortBy.valuesAscending = true;
      this.sortBy.valuesDescending = false;
      this.orderBy = ordinalAxis === 1 ? this.xAxis.slug : this.yAxis.slug;
    } else if (prop === 'valuesDescending') {
      this.sortBy.names = false;
      this.sortBy.valuesAscending = false;
      this.sortBy.valuesDescending = true;
      this.orderBy = ordinalAxis === 1 ? this.xAxis.slug : this.yAxis.slug;
    }

    this.setLegendOptions(this.dataToDraw);
    this.drawChart(this.dataToDraw);
  }

  /** Called on legend option is clicked */
  onLegendClickCheckbox(legendOptions, legendName, event) {
    let index = 0;
    const unchecks = this.checkboxStillEnabled(legendOptions);
    if (unchecks > 2) {
      legendOptions.find(function (element) {
        if (element.name === legendName) {
          legendOptions[index].active = !legendOptions[index].active;
        }
        index++;
      });
      this.checkboxDisabled = false;
      this.onLegendClick(legendOptions);
    } else if (unchecks === 2) {
      legendOptions.find(function (element) {
        if (element.name === legendName) {
          legendOptions[index].active = !legendOptions[index].active;
        }
        index++;
      });
      if (event.checked === false) { // If disabled one of the 2 checkboxes left
        this.checkboxDisabled = true;
      }
      this.onLegendClick(legendOptions);
    } else if (unchecks === 1) {
      legendOptions.find(function (element) {
        if (element.name === legendName) {
          legendOptions[index].active = true;
        }
        index++;
      });
      this.checkboxDisabled = false;
      this.onLegendClick(legendOptions);
    }
  }

  /** Check if checkbox shlud be enabled still */
  checkboxStillEnabled(legendOptions) {
    let counter = 0;
    for (let i = 0; i < legendOptions.length; i++) {
      if (legendOptions[i].active === true) {
        counter++;
      }
    }
    return counter;
  }

  /** Called on legend click to draw chart again */
  onLegendClick(legendOptions) {
    this.legendOptions = legendOptions;
    this.drawChart(this.dataToDraw);
  }

  /** Filters configuration with names and disabled options */
  filtersConfig() {
    const config = {
      names: {
        unidad: 'Unidad',
        columns: this.selectedQuestion ? this.selectedQuestion.categoryName : 'Variable',
        categories: this.selectedQuestion ? this.selectedQuestion.subcategoryName || this.selectedQuestion.categoryName : 'Categoría',
        secondColumns: this.selectedSecondQuestion ? this.selectedSecondQuestion.categoryName : 'Variable',
        secondCategories: this.selectedSecondQuestion ?
          this.selectedSecondQuestion.subcategoryName || this.selectedSecondQuestion.categoryName : 'Categoría',
      },
      disabled: {
        unidad: {
          'Total': false,
          'Porcentaje': false,
          'Promedio': this.collapseBy && this.collapseBy.slug === this.selectedQuestion.collapseBy
            && this.selectedChart !== 'heatmap' && this.selectedChart !== 'spineplot'
        },
        columns: false, // this.groupedBy === 'columns',
        categories: this.selectedQuestion.kind === 'columna',
        secondColumns: false, // this.groupedBy === 'secondColumns',
        secondCategories: false, // this.groupedBy === 'secondCategories'
      }
    };
    if (this.selectedQuestion && this.selectedQuestion.fieldOptions) {
      this.selectedQuestion.fieldOptions.forEach(option => {
        if (!config.names[option.slug]) {
          config.names[option.slug] = option.name;
          config.disabled[option.slug] = false;
        }
      });
    }
    return config;
  }

  /** Second filters configuration with names and disabled options */
  secondFiltersConfig() {
    return {
      names: {
        columns: this.selectedSecondQuestion ? this.selectedSecondQuestion.categoryName : 'Variable',
        categories: this.selectedSecondQuestion ?
          this.selectedSecondQuestion.subcategoryName || this.selectedSecondQuestion.categoryName : 'Categoría'
      },
      disabled: {
        columns: this.groupedBy === 'columns',
        categories: this.groupedBy === 'categories'
      }
    };
  }

  /** Called when chart was already drawn */
  onChartLoaded(chart) {
    // Do something when chart has loaded...
  }

  /** OnDestroy component. Unsubscribe from params */
  ngOnDestroy() {
    this.subQueryParams.unsubscribe();
    this.sub.unsubscribe();
  }

  /** Filter second variables by name */
  filterSecondVariables(name: string) {
    if (typeof name === 'string') {
      return this.secondVariables.filter(variable =>
        variable.shortName.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['question']) {
      if (this.selectedSecondQuestion.questionId !== name['questionId']) {
        // variable is a selected object
        this.selectedSecondQuestion = name;
        this.dbService.getRowsFromQuestionId(this.selectedSecondQuestion.questionId)
          .subscribe(categories => {
            this.filterOptions.secondCategories = [ALL].concat(categories.map(c => c['name']) as string[]);
            this.selectedFilters['secondCategories'] = ALL;
          }, error => {
            const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
              panelClass: 'light-themed-dialog',
              width: '400px',
              data: {
                error: error.error ? error.error.message.toString() :
                  (error.statusText.toString() || error.message.toString() || error)
              }
            });
          });

        this.dbService.getColumnsFromQuestionId(this.selectedSecondQuestion.questionId)
          .subscribe(columns => {
            this.filterOptions.secondColumns = [ALL].concat(columns.map(c => c['name']) as string[]);
            this.selectedFilters['secondColumns'] = ALL;
          }, error => {
            const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
              panelClass: 'light-themed-dialog',
              width: '400px',
              data: {
                error: error.error ? error.error.message.toString() :
                  (error.statusText.toString() || error.message.toString() || error)
              }
            });
          });

        this.updateChart();
      }
      return this.secondVariables.filter(variable =>
        this.utils.stripSpecialCharacters(variable.shortName).indexOf(this.utils.stripSpecialCharacters(name['question'])) > -1);
    }
  }

  /** Erase second autocomplete for variables */
  eraseSecondSearch() {
    this.searchSecondQuestion.setValue(undefined);
  }

  /**
   * Sorts names of variables alphabetically
   * @param a name of first variable to compare
   * @param b name of second variable to compare
   */
  sortVariables(a, b) {
    return a.shortName.localeCompare(b.shortName, undefined, { numeric: true });
  }

  /**
   * Sorts names of groups alphabetically
   * @param a name of first group to compare
   * @param b name of second group to compare
   */
  sortGroups(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  /** Generate group items */
  generateGroupItems() {
    const items = Object.assign({}, this.axisOptions);

    this.groupByItems = _.filter(items, item => {
      return item.type === 'ordinal';
    });
    this.groupByItems.push({
      name: 'Sin desagregación',
      type: 'ordinal',
      slug: ''
    });

    this.groupByItems = this.groupByItems.sort(this.sortGroups);
  }

  /** Generate selected filters with filter options available */
  generateSelectedFilters() {
    Object.keys(this.filterOptions).forEach(function (fk) {
      if (fk === 'unidad') {
        this.selectedFilters[fk] = this.selectedQuestion.kindAnswer === 0 ? 'Porcentaje' : 'Promedio';
      } else if (this.filterOptions[fk][0]) {
        this.selectedFilters[fk] = this.filterOptions[fk][0];
      } else {
        this.selectedFilters[fk] = ALL;
      }
    }.bind(this));
  }

  /** Include if question is "Barreras de acceso" */
  includedQuestion() {
    return (this.selectedQuestion && this.selectedQuestion.shortName.indexOf('Barreras de acceso a información gubernamental') > -1);
  }

  /** Switch between chart and table */
  switchDataView() {
    this.switchViewMob = !this.switchViewMob;
  }

  /** Screen width resizing listener */
  @HostListener('window:resize', ['$event'])

  /**
   * Reads if size of screen is changing
   * @param event Not used
   */
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 600) { // Lower than mobile screen width
      this.enableMobileMenu = true;
    } else {
      this.enableMobileMenu = false;
    }
  }

  /** Toggle horizontal and vertical axes */
  toggleAxes() {
    const tmpAxes = this.xAxisOptions;
    this.xAxisOptions = this.yAxisOptions;
    this.yAxisOptions = tmpAxes;
    const tmp = this.yAxis;
    this.yAxis = _.find(this.yAxisOptions, { slug: this.xAxis.slug });
    this.xAxis = _.find(this.xAxisOptions, { slug: tmp.slug });
    if (this.selectedChart === 'heatmap' || this.selectedChart === 'spineplot') {
      this.disabledYAxis = this.disabledXAxis = false;
      this.groupedBy = this.yAxis.type === 'ordinal' ? this.yAxis.slug : '';
    } else {
      this.disabledYAxis = !this.disabledYAxis;
      this.disabledXAxis = !this.disabledXAxis;
    }
    this.drawChart(this.dataToDraw);
  }

  /** Show or hide labels */
  showLabels() {
    this.labelsVisible = !this.labelsVisible;
    this.showSizeOption = false;
  }

  /** Show color palettes options available */
  showColors() {
    this.showColorsOptions = !this.showColorsOptions;
    this.showLabelsOptions = false;
    this.showSizeOption = false;
  }

  /** Show labels' size options */
  showSize() {
    this.showSizeOption = !this.showSizeOption;
    this.showLabelsOptions = false;
    this.showColorsOptions = false;
  }

  /** Toggle stacked or grouped bars */
  toggleStackedOrGrouped() {
    this.stackBy = !this.stackBy;
    this.drawChart(this.dataToDraw);
  }

   /**
   * assign palette selected, to
   * @param palette Palette of colors selected
   */
  selectPalette(palette: string[]) {
    this.colors = palette;
    if (this.dataToDraw) {
      this.drawChart(this.dataToDraw);
    }
  }

  /** Increase size of labels font */
  increaseSize() {
    this.fontBars = d3.selectAll('.dbox-label').style('font-size', () => {
      this.resBars = parseFloat(d3.selectAll('.dbox-label').style('font-size').split('%')[0]);
      this.resBars += 2.5;
      return this.resBars + 'px';
    });
    return this.fontBars;
  }

  /** Decrease size of labels font */
  decreaseSize() {
    this.fontBars = d3.selectAll('.dbox-label').style('font-size', () => {
      this.resBars = parseFloat(d3.selectAll('.dbox-label').style('font-size').split('%')[0]);
      this.resBars -= 2.5;
      return this.resBars + 'px';
    });
    return this.fontBars;
  }

  /**
   * return true if color intersection is bigger than 5
   * @param palette palette of colors selected
   */
  paletteIsSelected(palette) {
    return _.intersection(this.colors, palette).length > 5;
  }
}



// WEBPACK FOOTER //
// ./src/app/enadis/enadis-graphs/enadis-graphs.component.ts